<template>
  <div class="snow-input-file">
    <div class="input-container text-center">
      <input
        ref="input"
        type="file"
        :id="id"
        @change="fileChange($event.target.files)"
      />
      <button
        v-if="value"
        class="btn remove-button fa-light fa-close"
        @click="resetFile"
      />

      <div class="image-container" v-if="value && isImage">
        <img :src="value" alt="" />
      </div>

      <template v-else-if="fileName">
        <i class="fa-light fa-file text-dark fs-32 fw-4" />
        <div class="text-dark fs-14 mt-3 mb-5">
          {{ fileName }}
        </div>
      </template>

      <template v-else>
        <img
          src="@/assets/images/uploadSimple.svg"
          class="p-4 rounded-36 bg-dark-4 mb-5"
        />
        <div class="fs-18 text-semibold mt-5 mb-2" v-if="title">
          {{ title }}
        </div>
        <div class="text-dark-40 fs-14" v-if="maxSize">
          JPG e PNG de até {{ maxSize }}MB
        </div>
        <div class="text-dark-40 fs-14" v-if="dimensions">
          Dimensões recomendadas: <br />
          {{ dimensions }}px
        </div>
      </template>
    </div>
    <div class="text-dark-40" v-if="supportingText">
      {{ supportingText }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [File, String],
      default: null
    },
    id: {
      type: String,
      default: "snow-input-file"
    },
    title: {
      type: String,
      default: "Importar"
    },
    maxSize: {
      type: [String, Number],
      default: 5
    },
    dimensions: String,
    supportingText: String,
    isImage: Boolean
  },
  data() {
    return {
      fileName: ""
    };
  },
  methods: {
    resetFile() {
      this.$refs.input.value = "";
      this.$emit("input", null);
      this.fileName = "";
    },
    fileChange(files) {
      if (!files) return;

      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = parseInt(Math.floor(Math.log(files[0].size) / Math.log(1024)));
      const size =
        Math.round(files[0].size / Math.pow(1024, i), 2) + " " + sizes[i]; // convert to mb and show unit meansurement

      if (
        size.match("MB") &&
        /([^MB]*)MB/.exec(size)[1] > parseInt(this.maxSize)
      ) {
        this.$message.error(`O arquivo deve ter no máximo ${this.maxSize}MB`);
        return;
      }

      if (
        this.isImage &&
        !["png", "jpg", "jpeg", "webp"].includes(
          this.getExtension(files[0].name)
        )
      ) {
        this.$message.error(
          "O arquivo deve ter extensão .png, .jpg, .jpeg ou .webp"
        );
        return;
      }

      this.getFile(files[0]).then(file => {
        this.fileName = files[0].name;
        this.$emit("input", file);
      });
    },
    getFile(file) {
      return new Promise(resolve => {
        const fReader = new FileReader();

        fReader.onload = () => {
          resolve(fReader.result);
        };

        fReader.readAsDataURL(file);
      });
    },
    getExtension(name) {
      const filename = `${name}`.toLowerCase();
      return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
    }
  },
  watch: {
    value(v) {
      if (!v) this.resetFile();
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-input-file {
  width: 100%;
  @media screen and (min-width: 768px) {
    min-width: 292px;
  }

  .input-container {
    width: 100%;
    aspect-ratio: 2;
    border-radius: 16px;
    background-color: var(--bg-2);
    padding: 62px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    line-break: anywhere;

    input {
      cursor: pointer;
      opacity: 0;
      position: absolute;
      inset: 0;
      &::file-selector-button {
        display: none;
      }
    }

    .image-container {
      display: flex;
      width: 100%;
      justify-content: center;

      img {
        max-width: 100%;
        border-radius: 4px;
        transition: filter 0.2s;

        @media screen and (max-width: 991px) {
          max-height: 100vw;
        }
      }
    }

    .remove-button {
      position: absolute;
      z-index: 10;
      right: 12px;
      top: 12px;
      padding: 2px;
      aspect-ratio: 1;
      border-radius: 100%;
      min-height: 20px;
      height: 20px;
      background-color: rgba(215, 215, 215, 1);
      color: #e7373a;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
